import React from 'react';
import {
  Box,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Text,
} from '@chakra-ui/react';
import { Info } from 'phosphor-react';

interface InfoPopoverProps {
  /** Titulo curto exibido no header do popover. */
  title?: string;
  /** Conteudo principal — texto simples ou JSX. */
  children: React.ReactNode;
  /** Tamanho do icone (default 14). */
  size?: number;
}

/**
 * Tooltip-toggle: ícone "i" circular que ao CLICAR abre/fecha um popover
 * com explicação. Usado em KPIs, headers de tabela, status — pra usuários
 * leigos entenderem o significado de cada coisa.
 */
export const InfoPopover = ({ title, children, size = 14 }: InfoPopoverProps) => (
  <Popover trigger="click" placement="top" closeOnBlur>
    <PopoverTrigger>
      <IconButton
        aria-label="Mais informações"
        icon={<Info size={size} weight="duotone" />}
        size="xs"
        variant="ghost"
        color="gray.400"
        _hover={{ color: 'blue.500', bg: 'blue.50' }}
        h="auto"
        minW="auto"
        p={0.5}
      />
    </PopoverTrigger>
    <Portal>
      <PopoverContent fontSize="sm" maxW="320px" boxShadow="xl" zIndex={1500}>
        <PopoverArrow />
        <PopoverCloseButton />
        {title && (
          <PopoverHeader fontWeight="bold" fontSize="sm">
            {title}
          </PopoverHeader>
        )}
        <PopoverBody>
          {typeof children === 'string' ? (
            <Text fontSize="xs" color="gray.700" lineHeight="1.5">
              {children}
            </Text>
          ) : (
            <Box fontSize="xs" color="gray.700">
              {children}
            </Box>
          )}
        </PopoverBody>
      </PopoverContent>
    </Portal>
  </Popover>
);
